@if (isCategoryPage) {
  <div class="c__wrapper">
    <div class="c__title">
      <sd-title
        [titleLevel]="2"
        [customClass]="'brand--h3 is-text-' + positionEnum.center"
        [titleThemesConfig]="brandThemesEnum.brand"
        data-testid="title"
      >
        {{ currentCategory ?? '' }}
      </sd-title>
        
      @if (totalProducts) {
        <sd-title
          [titleLevel]="2"
          [customClass]="'is-medium is-text-' + positionEnum.center"
          [isDescription]="true"
          data-testid="description"
        >
          {{ (totalProducts ?? '') + '&nbsp;' + ('product.products' | translate) }}
        </sd-title>
      }
    </div>
    <wc-sibling-categories
      [categoryData]="categoryData"
      data-testid="sibCategories"
    />
  </div>
}

@if (isLoading || ((filters && orderByValues) || superFilters.length) || priceRange) {
  <sd-filters
    id="product-card-grid-filters"
    [showButton]="!isAccessories"
    [isAlwaysOpen]="isAccessories"
    [brand]="brandCorner"
    [filters]="filters"
    [superFilters]="superFilters"
    [formRange]="priceRange"
    [orderSelectConfig]="orderByValues"
    [titleLevel]="2"
    (selectedFilters)="onSelectedFilters($event)"
    (orderedBy)="onSortSelected($event)"
    (selectedSuperFilters)="onSelectedSuperFilters($event)"
    (selectedPriceRange)="onSelectedPriceRange($event)"
  />
}

<div class="c__product-grid-wrapper">
  <ul class="c__items">
    @if (!isLoading) {
      @for (card of cards; track card.type + '_' + card.id) {
        <li class="c__item">
          @if (card.type === 'product' || card.type === 'bundle') {
            <sd-product-card
              [isSSR]="isSSR"
              [displayStock]="card?.product?.productGenre !== 'Forfait'"
              [brand]="brandCorner ? brandCorner : !card?.product?.isAccessory ? card.product?.brand : brandEnum.default"
              [indexFollow]="card.product?.indexFollow"
              [productInfo]="card.product"
              [titleLevel]="productGridTitleLevel"
              id="{{ card.product.code }}"
              [isBundle]="card.type.toUpperCase() === cartGroupTypeEnum.BUNDLE"
              [twicPicsAutoSize]="false"
              [showRef]="isSis || isAccessories"
              [horizontalLayout]="isMobile"
              [(isCompared)]="isProductsInComparator[card.product.code]"
              (isComparedChange)="addOrRemoveToComparator($event, card.product)"
              (cart)="addToCart($event)"
              (notify)="notifyMe($event)"
              (productClicked)="onProductClick($event)"
              (productSellerModal)="openSellerModal()"
              (reviewsSeeAllClicked)="onReviewsSeeAllClicked(card.product)"
              (openRecommendedPriceModal)="openRecommendedPriceModal()"
            />
          }
          @if (card.type === 'push') {
            <article>
              <sd-push-card
                #pushCardComponent
                [brand]="brandCorner"
                (click)="onPromoClick(card.push.push)"
                [pushSize]="pushSizeEnum.m"
                [textConfig]="card.push.textConfig"
                [mediaConfig]="card.push.mediaConfig"
                [push]="card.push.push"
                [imageRatio]="card.push.imageRatio"
                [titleLevel]="3"
                [themesConfig]="card.push.themesConfig"
                [mediaAsBackground]="card.push.mediaAsBackground"
                [twicPicsAutoSize]="false"
              />
            </article>
          }
        </li>
      }
    } @else {
      @for (card of skeletonCards; track $index) {
        <li class="c__item">
          <sd-product-card
            [isSSR]="false"
            [isLoading]="true"
            [productInfo]="card"
            [brand]="brandCorner"
            [horizontalLayout]="isMobile"
          />
        </li>
      }
    }
  </ul>
</div>

@if (pagination.totalPages > 1) {
  <div class="c__actions">
    <sd-pagination
      [brand]="brandCorner"
      [linkUrl]="linkUrl"
      [activePage]="(pagination.currentPage + 1)"
      [pages]="pagination.totalPages"
      (clickedPage)="onClickedPage($event)"
    />
  </div>
}

<sd-product-seller-modal [(isOpened)]="isOpenedSellerModal" />

<wc-product-notification-modal
  [productCode]="notifyProduct"
  [productName]="notifyProductName"
  [(notifyModalOpened)]="notifyModalOpened"
/>

<wc-omnibus-recommended-price-modal [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal" />

<span [wcCxJsonLd]="jsonLdData"></span>
